import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollRequestHelper  {
    _originalTypeClassName = "zSHR.BO.PayrollRequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollRequestHelper.translate = translateService;
}
this.PayrollRequestHelperKey = null;
this._key = this.PayrollRequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollRequestHelperKey:any;
get PayrollRequestHelperKey(): any {
    return this._PayrollRequestHelperKey;
  }
set PayrollRequestHelperKey(value: any) {
    this._PayrollRequestHelperKey = value;
    this._key = value;
  }

static DownloadFile($this: any, id: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollRequestHelperKey == null || $this.PayrollRequestHelperKey == 0;
            }


}